// AUTOGENERATED FROM packages/deploy/addresses.json — DO NOT EDIT BY HAND. Run `pnpm generate` (from packages/chains) to refresh.
import type { Address } from 'viem';

// Source: packages/deploy/addresses.json. Refresh this when local deploy addresses change.
export const localAddresses = {
  accessControlManager: '0xa16E02E87b7454126E5E10d957A927A7F5B5d2be',
  comptrollerLens: '0xeEBe00Ac0756308ac4AaBfD76c05c4F3088B8883',
  flashLoanFacet: '0x07e7876A32feEc2cE734aae93d9aB7623EaEF4a3',
  irmAlpha: '0x392ec8958dC3cd14c4F4e5585c54297d24D1a877',
  irmWTAO: '0x8eAeE502828c6C6f3e83Df32660a68fCe513Ce8a',
  marketFacet: '0x86337dDaF2661A069D0DcB5D160585acC2d15E9a',
  mockAlpha30: '0x4441cd5CeDDcdC29bA2C737d124Eb989cE3d373f',
  mockAlpha64: '0x7e134579b2f4a90136e3B5D905C753C8fD72D1Cc',
  policyFacet: '0x9CfA6D15c80Eb753C815079F2b32ddEFd562C3e4',
  resilientOracle: '0xB7A5bd0345EF1Cc5E66bf61BdeC17D2461fBd968',
  rewardFacet: '0x275039fc0fd2eeFac30835af6aeFf24e8c52bA6B',
  setterFacet: '0x427f7c59ED72bCf26DfFc634FEF3034e00922DD8',
  unitroller: '0x10C6E9530F1C1AF873a391030a1D9E8ed0630D26',
  vAlpha30: '0x081B46D94207710471669a89216E26B5C6c5a82d',
  vAlpha64: '0x038B11d1ee1D54C35A379417aB078F1213EF0C8B',
  vWTAO: '0xA0973567D4C0F9b04CbE2c0e95CeDb4465F4e4d1',
  wtao: '0xBfd66D9636253f11aE43f3428e8df73b5aD6950f',
  bittensorNativeAlphaFeed: '0x0000000000000000000000000000000000000001',
  wAlphaStashFaucet: '0x0000000000000000000000000000000000000001',
  wAlpha288: '0x0000000000000000000000000000000000000001',
  wAlpha333: '0x0000000000000000000000000000000000000001',
  wAlpha418: '0x0000000000000000000000000000000000000001',
  wAlphaPriceFeed288: '0x0000000000000000000000000000000000000001',
  wAlphaPriceFeed333: '0x0000000000000000000000000000000000000001',
  wAlphaPriceFeed418: '0x0000000000000000000000000000000000000001',
  vWAlpha288: '0x0000000000000000000000000000000000000001',
  vWAlpha333: '0x0000000000000000000000000000000000000001',
  vWAlpha418: '0x0000000000000000000000000000000000000001',
} as const satisfies Record<string, Address>;
